import React from "react";
import EconomicTable from "../EconomicTable";
import { useMarketInternalsData } from "../../../context/MarketInternalsContext";

const YieldsTab = () => {
    const { filteredRows: rows } = useMarketInternalsData();
    const data = rows.filter(row => row.Category === "YIELDS");
    return <EconomicTable data={data} title="Yields Analysis" defaultRowData={{ Category: "YIELDS", Topic: "Yields" }} groupBy="Topic" groupOrder={["Yields", "Spreads"]} useDataHook={useMarketInternalsData} />;
};

export default YieldsTab;
